import { ResponsibleInvestmentPage } from '../components/pages'

export default ResponsibleInvestmentPage
